// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/session_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { DisplayLanguage, OrganizationLanguage } from "./session_model_pb";
import { file_bffuser_v1_session_model } from "./session_model_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/session_service.proto.
 */
export const file_bffuser_v1_session_service: GenFile = /*@__PURE__*/
  fileDesc("CiBiZmZ1c2VyL3YxL3Nlc3Npb25fc2VydmljZS5wcm90bxIKYmZmdXNlci52MSIaChhHZXRDdXJyZW50U2Vzc2lvblJlcXVlc3Qi9gEKGUdldEN1cnJlbnRTZXNzaW9uUmVzcG9uc2USQwoVb3JnYW5pemF0aW9uX2xhbmd1YWdlGAEgASgOMiAuYmZmdXNlci52MS5Pcmdhbml6YXRpb25MYW5ndWFnZUICGAESGQoRb3JnYW5pemF0aW9uX25hbWUYAiABKAkSLwoLc2VydmVyX3RpbWUYAyABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEhEKCW1lbWJlcl9pZBgEIAEoCRI1ChBkaXNwbGF5X2xhbmd1YWdlGAUgASgOMhsuYmZmdXNlci52MS5EaXNwbGF5TGFuZ3VhZ2UydAoOU2Vzc2lvblNlcnZpY2USYgoRR2V0Q3VycmVudFNlc3Npb24SJC5iZmZ1c2VyLnYxLkdldEN1cnJlbnRTZXNzaW9uUmVxdWVzdBolLmJmZnVzZXIudjEuR2V0Q3VycmVudFNlc3Npb25SZXNwb25zZSIAQkBaPmdpdGh1Yi5jb20vZW5lY2hhaW4vZWJhbGFuY2UvZ28vZ2VuL3Byb3RvL2JmZnVzZXIvdjE7YmZmdXNlcnYxYgZwcm90bzM", [file_bffuser_v1_session_model, file_google_protobuf_timestamp]);

/**
 * GetCurrentSessionRequest has no fields.
 *
 * @generated from message bffuser.v1.GetCurrentSessionRequest
 */
export type GetCurrentSessionRequest = Message<"bffuser.v1.GetCurrentSessionRequest"> & {
};

/**
 * Describes the message bffuser.v1.GetCurrentSessionRequest.
 * Use `create(GetCurrentSessionRequestSchema)` to create a new message.
 */
export const GetCurrentSessionRequestSchema: GenMessage<GetCurrentSessionRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_session_service, 0);

/**
 * @generated from message bffuser.v1.GetCurrentSessionResponse
 */
export type GetCurrentSessionResponse = Message<"bffuser.v1.GetCurrentSessionResponse"> & {
  /**
   * Display language configured for the organisation. Deprecated: the
   * frontend reads display_language. Kept (still the organisation language)
   * so that frontend bundles already loaded in browsers keep working.
   *
   * @generated from field: bffuser.v1.OrganizationLanguage organization_language = 1 [deprecated = true];
   * @deprecated
   */
  organizationLanguage: OrganizationLanguage;

  /**
   * Display name of the organisation as registered in eCloud (eAuth), shown
   * in the ticker bar (spec common/shared-components.md AC-SC-010-3). This is
   * a display attribute only. Empty when eauth has no name registered; the frontend
   * then falls back to a default label.
   *
   * @generated from field: string organization_name = 2;
   */
  organizationName: string;

  /**
   * Server-side "now", passed through from the backend
   * (internalapi.v1.GetSessionResponse.server_time — same field number). The
   * frontend keeps a clock offset derived from it so that "today" / GC
   * judgements agree with the backend rather than with the browser wall
   * clock (~/models/clock.ts). Unset when the backend omitted it; the
   * frontend then falls back to the browser clock.
   *
   * @generated from field: google.protobuf.Timestamp server_time = 3;
   */
  serverTime?: Timestamp;

  /**
   * eauth member_id of the authenticated user, resolved server-side by the
   * BFF handler (eauth.GetMemberID) — not passed through from the backend,
   * which is why internalapi.v1.GetSessionResponse has no counterpart field
   * (it stops at 3). The BFF is the only layer that sees the eauth session,
   * and the decision this feeds is an authorisation display judgement, so the
   * id has to be the one the server itself resolved from the same session it
   * would authorise with.
   *
   * The frontend matches it against a bid's approvers so that approval /
   * reject stay pressable but warn a user who is not an approver or who is the
   * requester (spec docs/specs/bidding/spot-bidding.md AC-BSP-098,
   * docs/specs/bidding/intraday-bidding.md AC-BIN-098).
   *
   * Never empty in practice: the eauth interceptor rejects an unauthenticated
   * call before the handler runs, and the handler fails the RPC with
   * Unauthenticated when the session carries no member id. The frontend must
   * still treat an absent value as "not an approver" (fail-closed) rather
   * than suppressing the warning.
   *
   * @generated from field: string member_id = 4;
   */
  memberId: string;

  /**
   * Language the member sees eBalance in, passed through from the backend
   * (internalapi.v1.GetSessionResponse.display_language — same field number
   * 5): the member's eCloud personal-setting language, falling back to the
   * organisation language when unset. Used by the frontend to initialise i18n.
   * UNSPECIFIED means the backend could not determine it (member lookup
   * failed, or the BFF / backend pair is mid-deploy): the frontend keeps its
   * current language then.
   *
   * @generated from field: bffuser.v1.DisplayLanguage display_language = 5;
   */
  displayLanguage: DisplayLanguage;
};

/**
 * Describes the message bffuser.v1.GetCurrentSessionResponse.
 * Use `create(GetCurrentSessionResponseSchema)` to create a new message.
 */
export const GetCurrentSessionResponseSchema: GenMessage<GetCurrentSessionResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_session_service, 1);

/**
 * SessionService provides session-level information for the current user.
 *
 * @generated from service bffuser.v1.SessionService
 */
export const SessionService: GenService<{
  /**
   * GetCurrentSession returns session-level attributes for the authenticated
   * user's organisation, including the user's display language (their eCloud
   * personal-setting language, the organisation language when unset) used to
   * initialise frontend i18n.
   *
   * @generated from rpc bffuser.v1.SessionService.GetCurrentSession
   */
  getCurrentSession: {
    methodKind: "unary";
    input: typeof GetCurrentSessionRequestSchema;
    output: typeof GetCurrentSessionResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_bffuser_v1_session_service, 0);

